














































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ProductItem } from "../../common/interfaces";
import Store from "@/store/store";
import axios from "axios";
import { ActionNames } from "@/store/actions";

@Component({})
export default class MiscPart extends Vue {
  @Prop()
  public showDialog: boolean;
  public internalShowDialog: boolean = false;
  public loadingMiscPart: boolean = false;
  public addingMiscPart: boolean = false;
  public quantity: number = 1;
  public defaultMiscPart: ProductItem;
  public miscPart: ProductItem | null = null;
  public displayPrice: number = 0.0;

  public async mounted() {
    try {
      if (!this.defaultMiscPart) {
        await this.loadMiscPart();
      }
      this.miscPart = Object.assign({}, this.defaultMiscPart);
      this.updateInternal();
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: "Failed loading Miscellaneous Product",
        offset: 48,
      });
      this.$emit("miscPartClosed");
    } finally {
      this.loadingMiscPart = false;
    }
  }

  // Watchers so that element dialog .sync works with a prop
  @Watch("showDialog")
  public updateInternal() {
    this.internalShowDialog = this.showDialog;
  }

  @Watch("internalShowDialog")
  public updateExternal() {
    if (!this.internalShowDialog) {
      this.$emit("miscPartClosed");
    }
  }

  public async loadMiscPart() {
    this.loadingMiscPart = true;
    if (Store.state.Job.JobDetail) {
      const response = await axios.get(
        `${
          Store.state.Environment.ODataBaseUrl
        }/ProductItems(OperatingCompanyCode='${
          Store.state.Job.JobDetail.DivisionOperatingCompanyCode
        }',ProductItemId='MISCFIT')?$select=OperatingCompanyCode,ProductItemId,Description,SellingPrice,SellDecimals`,
        {
          headers: {
            Authorization: "Bearer " + Store.state.User.AccessToken,
          },
        }
      );

      if (response.status === 200 && response.data) {
        this.defaultMiscPart = response.data.value[0];
      }
    }

    this.loadingMiscPart = false;
  }
  public priceChanged(newValue: number) {
    if (this.miscPart && newValue >= 0.0) {
      this.displayPrice = newValue;
      const SellDecimals = this.miscPart.SellDecimals || 2;
      this.miscPart.SellingPrice = newValue * Math.pow(10, SellDecimals);
    }
  }

  public validateMiscPart() {
    return (
      this.miscPart &&
      this.miscPart.Description &&
      this.miscPart.SellingPrice! > 0
    );
  }

  public async addMiscPart() {
    const savingMiscPart = this.$loading({
      target: ".misc-part .el-dialog",
    });

    if (this.validateMiscPart()) {
      try {
        // add the misc part to quote
        if (this.miscPart) {
          await Store.dispatch(ActionNames.AddPartToQuote, {
            product: this.miscPart,
            quantity: this.quantity,
            price: this.miscPart.SellingPrice,
          });
          savingMiscPart.close();
          this.closeDialog();
        }
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48,
        });
      }
    } else {
      this.$notify.error({
        title: "Error",
        message: "A Miscellaneous Product must have a description and price.",
        offset: 48,
      });
    }
    savingMiscPart.close();
  }

  public incrementQuantity() {
    this.quantity += 1;
  }

  public decrementQuantity() {
    if (!(this.quantity - 1 <= 0)) {
      this.quantity -= 1;
    }
  }

  public closeDialog() {
    this.$emit("miscPartClosed");
  }

  get displayTotal() {
    // default sell decimals to 2, if there is a sell decimal on the misc part use that
    let sellDecimals = 2;
    if (this.miscPart) {
      sellDecimals = this.miscPart.SellDecimals || 2;
    }
    return (this.displayPrice * this.quantity).toFixed(sellDecimals);
  }
}
